import type {ReactNode} from 'react';

const Svg = ({children}: {children: ReactNode}) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        {children}
    </svg>
);
export const SpeakerIcon = () => (
    <Svg>
        <path d="M4 9v6h4l5 4V5L8 9z" />
        <path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11" />
    </Svg>
);
export const SpeakerOffIcon = () => (
    <Svg>
        <path d="M4 9v6h4l5 4V5L8 9z" />
        <path d="M17 9l5 6M22 9l-5 6" />
    </Svg>
);
export const PlayIcon = () => (
    <Svg>
        <path d="M7 4l13 8-13 8z" />
    </Svg>
);
export const PlusIcon = () => (
    <Svg>
        <path d="M12 5v14M5 12h14" />
    </Svg>
);
export const MinusIcon = () => (
    <Svg>
        <path d="M5 12h14" />
    </Svg>
);
export const CrossIcon = () => (
    <Svg>
        <path d="M6 6l12 12M18 6L6 18" />
    </Svg>
);
export const GripIcon = () => (
    <Svg>
        <path d="M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01" />
    </Svg>
);
export const ArrowLeftIcon = () => (
    <Svg>
        <path d="M19 12H5M11 6l-6 6 6 6" />
    </Svg>
);
export const CheckIcon = () => (
    <Svg>
        <path d="M5 12l5 5 9-10" />
    </Svg>
);
